import type { PdfiumApi } from "@pdfking/renderer-wasm-pdfium"

import type { ReadDocumentResult } from "./ReadDocument"

export const CloseDocument = async (
  api: PdfiumApi,
  result: ReadDocumentResult
): Promise<void> => {
  if (result.doc_pointer) {
    await api.call("FPDF_CloseDocument", result.doc_pointer)
  }
  for (const func of result.cleanup_functions || []) {
    func()
  }
  for (const key in result.blobs_array) {
    delete result.blobs_array[key]
  }
}
